import React from 'react';

const HeaderContext = React.createContext(() => null);

export default HeaderContext;